// src/api.js
// API utama untuk flow auth dan solid data (upload, fetch dokumen, organisasi)

// Membuat header auth
export const authHeaders = (extra = {}) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    ...extra,
  };
  return headers;
};

// Ambil daftar organisasi user
export const getOrganizationsFromBackend = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token tidak ditemukan. Silakan login.");
  const res = await fetch("https://bot.kediritechnopark.com/webhook/soliddata/get-organization", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return await res.json();
};

// Pilih organisasi aktif
export const pickOrganization = async (organization_id, nama_organization) => {
  const token = localStorage.getItem("token");
  const chosen = { organization_id, nama_organization };
  await fetch("https://bot.kediritechnopark.com/webhook/soliddata/pick-organization", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(chosen),
  });
  localStorage.setItem("selected_organization", JSON.stringify(chosen));
};

// Ambil daftar tipe dokumen (jenis dokumen)
export const fetchDocumentTypes = async (organizationId) => {
  const token = localStorage.getItem("token");
  const res = await fetch(
    "https://bot.kediritechnopark.com/webhook/solid-data/files",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ organization_id: organizationId }),
    }
  );
  return await res.json();
};

// Ambil entry/data per tipe dokumen
export const fetchEntries = async (dataTypeId) => {
  const token = localStorage.getItem("token");
  const res = await fetch(
    "https://bot.kediritechnopark.com/webhook/solid-data/files/entry",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ data_type_id: dataTypeId }),
    }
  );
  return await res.json();
};

// Upload dokumen (gambar/file)
export const uploadDocument = async (organizationId, dataTypeId, file) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("organization_id", organizationId);
  formData.append("data_type_id", dataTypeId);
  formData.append("file", file);
  const res = await fetch("https://bot.kediritechnopark.com/webhook/solid-data/upload", {
    method: "POST",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: formData,
  });
  return await res.json();
};

